( function( $ ) {

// var uploader;
var pageId = 'page-member-settings-password',
	page = '#' + pageId;

$( function() {
	$(document)
	.on('ajax:success', '.form-member-setting-password', function(e, result) {
		if (result.success && result.target_url) {
			location.href = result.target_url;
		}
	});
	/*
	var placeholder = "***********";

	$('body').on( "validate", page + " #txt-password", function( e, val ) {
		var result = { valid: true },
			old = $.trim($( "#txt-old-password" ).val());

		if (old && old !== placeholder && (val === placeholder || !val.length)) {
			result = {
				valid: false,
				errorMsg: "新密码不能为空"
			};
		}

		return result;
	})
	.on( "focus", page + " #txt-password," + page + " #txt-old-password", function( e, val ) {
		var txt = $( this );
		if ( txt.val() == placeholder ) {
			txt.val( "" );
		}
		txt.addClass( "on" );
	})
	.on( "blur", page + " #txt-password," + page + " #txt-old-password", function( e, val ) {
		var txt = $( this );
		if ( txt.val() == "" ) {
			txt.val( placeholder )
				.removeClass( "on" );
		} else {
			txt.addClass( "on" );
		}
	})
	.on( "validate", page + " #txt-old-password", function( e, val ) {
		var result = { valid: true },
			pw = $.trim($( "#txt-password" ).val());

		if (pw && pw !== placeholder && (val === placeholder || !val.length)) {
			result = {
				valid: false,
				errorMsg: "现有密码不能为空"
			};
		}

		return result;
	})
	.on( "ajax:before", page + " .form", function( e, xhr, settings ) {
		var txtPassword = $( "#txt-password" );
		if ( txtPassword.val() && txtPassword.hasClass( "on" )) {
			txtPassword.attr( "name", "password" );
		} else {
			txtPassword.removeAttr( "name" );
		}

		var txtPassword = $( "#txt-old-password" );
		if ( txtPassword.val() && txtPassword.hasClass( "on" )) {
			txtPassword.attr( "name", "old_password" );
		} else {
			txtPassword.removeAttr( "name" );
		}
	});

	$( page + " #txt-password, " + page + " #txt-old-password" ).trigger('blur');
	*/
});


})( jQuery );
